import { DatePipe } from '@angular/common'
import { PropertyConverter } from 'angular2-jsonapi'

export class LocalDateConverter implements PropertyConverter {
    static datePipe = new DatePipe('pt')
    static invalidDates = ['0001-01-01', '1900-01-01', '-999999999-01-01']

    static toModel(value: any) {
        if (value instanceof Date) {
            return value
        }

        if (!value || LocalDateConverter.invalidDates.includes(value)) {
            return undefined
        }

        return new Date(`${value}T00:00:00`)
    }

    static toJSON(date: Date) {
        return LocalDateConverter.datePipe.transform(date, 'yyyy-MM-dd')
    }

    mask(value: any) {
        return LocalDateConverter.toModel(value)
    }

    unmask(value: any) {
        return LocalDateConverter.toJSON(value)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/converters/local-date.converter.ts